import React from 'react'

const PlaygroundPage = () => {
  return <div></div>
}

export default PlaygroundPage
